import { PageHeader } from "@/components/PageHeader";
import { StoreSettingsForm } from "./components/StoreSettingsForm";

export default function StoreSettingsPage() {
  return (
    <div className="container-elegant page-padding">
      <PageHeader title="Minha loja" />
      <StoreSettingsForm />
    </div>
  );
}
